import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-loading-spinner',
  templateUrl: './loading-spinner.component.html',
  styleUrls: ['./loading-spinner.component.scss']
})
export class LoadingSpinnerComponent implements OnInit {

  @Input() isLoading = false;

  constructor() {
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /opt/app/src/app/core/loading-spinner/loading-spinner.component.ts